import React, { useState, useEffect } from 'react';
import { colors } from '../../styles/colors';
import styled from 'styled-components';

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: ${colors.primary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5%;
  z-index: 1000;
  transition: all 0.3s ease;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const Logo = styled.img`
  height: 60px;
  width: auto;
  cursor: pointer;
`;

const Nav = styled.nav`
  display: flex;
  gap: 2rem;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: ${colors.white};
  text-decoration: none;
  font-size: 1rem;
  font-weight: 500;
  transition: color 0.3s ease;
  cursor: pointer;
  
  &:hover {
    color: ${colors.accent};
  }

  &.active {
    color: ${colors.accent};
  }
`;

const Contact = styled.div`
  color: ${colors.white};
  display: flex;
  align-items: center;
  gap: 0.5rem;
  
  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: ${colors.white};
  font-size: 2rem;
  cursor: pointer;
  
  @media (max-width: 768px) {
    display: block;
  }
`;

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);

      // Update active section based on scroll position
      const sections = ['home', 'about', 'amenities', 'location', 'contact'];
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <HeaderContainer style={{
      background: isScrolled ? colors.primary : 'transparent',
      boxShadow: isScrolled ? '0 2px 10px rgba(0, 0, 0, 0.1)' : 'none'
    }}>
      <Logo
        src={process.env.PUBLIC_URL + '/images/cdn-forresta-logo.png'}
        alt="Codename Forresta"
        onClick={() => scrollToSection('home')}
      />

      <Nav>
        <NavLink 
          onClick={() => scrollToSection('home')}
          className={activeSection === 'home' ? 'active' : ''}
        >
          Home
        </NavLink>
        <NavLink 
          onClick={() => scrollToSection('about')}
          className={activeSection === 'about' ? 'active' : ''}
        >
          About
        </NavLink>
        <NavLink 
          onClick={() => scrollToSection('amenities')}
          className={activeSection === 'amenities' ? 'active' : ''}
        >
          Amenities
        </NavLink>
        <NavLink 
          onClick={() => scrollToSection('location')}
          className={activeSection === 'location' ? 'active' : ''}
        >
          Location
        </NavLink>
        <NavLink 
          onClick={() => scrollToSection('contact')}
          className={activeSection === 'contact' ? 'active' : ''}
        >
          Contact Us
        </NavLink>
      </Nav>

      <Contact>
        <i className="fas fa-phone"></i>
        <a href="tel:+919870004341" style={{ color: colors.white, textDecoration: 'none' }}>
          +91 9870004341
        </a>
      </Contact>

      <MobileMenuButton>
        <i className="fas fa-bars"></i>
      </MobileMenuButton>
    </HeaderContainer>
  );
};

export default Header; 